import React from "react";
export const ToggleDrawerContext = React.createContext();
export default function ToggleDrawer({ children }) {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <ToggleDrawerContext.Provider value={[isOpen, setIsOpen]}>
      {children}
    </ToggleDrawerContext.Provider>
  );
}
